<template src="./notes.html"></template>
<script>
import { mapState } from "vuex";
import "jquery/dist/jquery.min.js";
import Endpoints from "@/config/ApiEndpoints.js";
import Axios from "axios";
import $ from "jquery";
import Swiper, { navigation } from "swiper";

export default {
  components: {},
  props: {
    RequestFor: String,
    ItemId: String / Number,
    Type: String / Number,
    ItemName: String / Number,
  },
  filters: {},
  data() {
    return {
      notes: {},
      NoteData: { title: "", notes: "", id: "" },
      ShowAddNotePopup: false,
      notes_export_data: [],
    };
  },
  mounted() {
    this.GetNotesList();
  },
  methods: {
    AddNote() {
      this.$parent.AddNote();
    },
    EditNote(note) {
      this.ShowAddNotePopup = true;
      this.NoteData.id = note.id;
      this.NoteData.title = note.title;
      this.NoteData.notes = note.notes;
    },
    SaveNotes() {
      $("#note_save_btn").html("Processing...");
      Axios.post(Endpoints.Notes.Update, {
        token: localStorage.getItem("token"),
        notes: this.NoteData.notes,
        title: this.NoteData.title,
        id: this.NoteData.id,
      }).then((Response) => {
        $("#note_save_btn").html("Save");
        if (Response.data.success == true) {
          this.NoteData.title = this.NoteData.notes = "";
          this.ShowAddNotePopup = false;
          this.GetNotesList();
          this.$swal(Response.data.message, "", "success").then(() => {});
        } else {
          this.$swal(Response.data.message, "", "error").then(() => {});
        }
      });
    },
    GetNotesList() {
      let formData = new FormData();
      formData.append("token", localStorage.getItem("token"));
      formData.append("item_id", this.ItemId);
      formData.append("type", this.Type);
      Axios.post(Endpoints.Notes.List, formData).then((Response) => {
        if (Response.data.success == true) {
          this.notes = Response.data.notes;
          this.notes_export_data = [];
          if (this.notes.length > 0) {
            this.notes.forEach((element) => {
              var obj = {};
              obj["Title"] = element.title;
              obj["Note"] = element.notes;
              if (this.RequestFor == "Driver") {
                obj["Driver Name"] = this.ItemName;
              } else if (this.RequestFor == "Vehicle") {
                obj["Vehicle"] = this.ItemName;
              } else if (this.RequestFor == "Trailer") {
                obj["Trailer"] = this.ItemName;
              } else if (this.RequestFor == "Assets") {
                obj["Serial No"] = this.ItemName;
              }

              obj["Date"] = element.date_display;
              this.notes_export_data.push(obj);
            });
          }
        }
      });
    },
    DeleteNote(note_id) {
      this.$swal
        .fire({
          title: "Are you sure You want to delete this note?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#514b71",
          cancelButtonColor: "#aaa",
          confirmButtonText: "Yes, delete it!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$swal.fire({
              title: "Deleting...",
              text: "Please wait...",
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.Notes.Delete, {
              token: localStorage.getItem("token"),
              id: note_id,
            }).then((Response) => {
              if (Response.data.success == true) {
                this.GetNotesList();
                this.$swal
                  .fire("Note Deleted Successfully", "", "success")
                  .then(() => {});
              } else {
                this.$swal
                  .fire("Error:" + Response.data.message, "", "error")
                  .then(() => {});
              }
            });
          }
        });
    },
  },
};
</script>
<style scoped>
.download-excel-btn {
  float: right;
  margin-right: 10px;
}
</style>
